import React, {Component} from 'react'
import {
    Select, message, Input, Table, Button, Popconfirm, Form, DatePicker, Row, Col,
    Upload, Radio, Checkbox, Tooltip,
} from 'antd';
import moment from 'moment';
import 'moment/locale/zh-cn';
import PackageModel from './packageModel';
import TrackModel from './preview/trackModel'
import {toStrFixed} from '../../utills/subStringUtill'
import {
    reqArea, reqAddress, getOrder, getPackages, reqUpdateTrack, savePackage, updatePackage, delPackage, baseUrl,
    reqRentalBox,reqGetShiftList
}from '../../api'
import authorizeBase from "../../components/authorize/authorizeBase";
import DetailUploadTable from '../order-ticket/detail-upload-table'
import SelectAreaFormItem from './select-area'
import SelectBoxFormItem from './select-box'
import SelectShiftItem from './select-shift'
import {handleChangeArea, handleChangeRentalBox, handleChangePackageType, range, IconFont,handleChangeShift} from '../../utills/common';
const AuthButton = authorizeBase(Button)
const AuthPopconfirm = authorizeBase(Popconfirm);
const {Option} = Select;
moment.locale('zh-cn');

let orderId = '';

const packageTypeStatus = {
    'packageTypeSmall' : '零售小包',
    'packageTypeNormal' : '本地一般贸易',
    'packageTypeNormalOut' : '外地一般贸易',
    'packageTypeDeclare' : '通关一体化',
    'packageTypeTransfer' : '转关运输',
    'packageTypeSale' : '寄售代销',
    'packageTypeB2b' :'B2B直接出口',
    'packageTypeOverseas' :'出口海外仓'
};
class OrderTrack extends Component {
    constructor(props) {
        super(props);
        this.state = {
            previewVisiable: false,
            action: '',
            packageManageVos: [],
            previewData: {},
            countryDataStart: [],
            stateDataStart: [],
            cityDataStart: [],
            countryDataEnd: [],
            stateDataEnd: [],
            cityDataEnd: [],
            consignorData: [],
            createdDt: "",
            notifyPartyData: [],
            deliveryPlaceData: [],
            origin: [],
            destination: [],
            importList: [],
            consigneeData: [],
            intiCityValue: '赣州',
            intiCountryValue: '中国',
            rentBox: [],
            returnBox: [],
            shiftList:[],
            shiftDt:'',
            packageType1: false,
            packageType2: false,
            packageType3: false,
            packageType4: false,
            packageType: [],
            packageTypeStatus:''
        }
    }

    componentDidMount() {
        orderId = this.props.location.state.orderId;
        this.getAddress(3);
        this.getAddress(2);
        this.getAddress(1);
        this.getAddress(6);
        const track = JSON.parse(sessionStorage.getItem("track"));
        if (track) {
            const deliveryEstimateDt = track.deliveryEstimateDt ? moment(track.deliveryEstimateDt, 'YYYY-MM-DD HH:mm:ss') : null;
            const tradeDt = track.tradeDt ? moment(track.tradeDt, 'YYYY-MM-DD HH:mm:ss') : null;
            this.props.form.setFieldsValue({deliveryEstimateDt: deliveryEstimateDt, tradeDt: tradeDt});
            this.setState(track);
        } else {
            this.initFormData();
            //this.goods(orderId);
        }
        this.getShiftList();
    }

    componentWillUnmount() {
        const curData = this.props.form.getFieldsValue();
        const stateData = this.state;
        const date = this.state.deliveryEstimateDt;
        const tradeDt = this.state.tradeDt;
        Object.assign(stateData, curData);
        stateData.deliveryEstimateDt = date;
        stateData.tradeDt = tradeDt;
        sessionStorage.setItem('track', JSON.stringify(stateData));
    }
    //获取班次信息
    getShiftList = async () => {
        let result = await reqGetShiftList();
        if (result.code === 200) {
            this.setState({
                shiftList:result.data
            });
        } else {
            message.error(result.message);
        }
    };
    judgeReadOnly = orderStatus => {
        if (orderStatus != 'new' && orderStatus != 'failed' && orderStatus != 'audit' && orderStatus != 'audited') {
            return true;
        }
        return false;
    };
    setInitAreaData = async (city, type) => {
        let result = await reqArea(type);
        if (result.code === 200) {
            let preInit;
            if (type === 'F') {
                preInit = city ? city : result.data[0].cityName;
                handleChangeArea(this, 'originCity', preInit, 'originCountry', 'origin', result.data);
            } else if (type === 'T') {
                preInit = city ? city : result.data[0].cityName;
                handleChangeArea(this, 'destinationCity', preInit, 'destinationCountry', 'destination', result.data);
            } else if (type === 'D') {
                preInit = city ? city : result.data[0].cityName;
                handleChangeArea(this, 'internationalEndCity', preInit, 'internationalEndCountry', 'international', result.data);
                handleChangeArea(this, 'destinationStartCity', preInit, 'destinationStartCountry', 'international', result.data);
            }
        } else {
            message.error(result.message);
        }
    };
    //租箱地rent_box,还箱地return_box
    setInitRentalBoxData = async (stationValue, type) => {
        let result = await reqRentalBox(type);
        if (result.code === 200) {
            if (type === 'rent_box') {
                handleChangeRentalBox(this, 'boxRentStation', stationValue, 'rentBox', result.data)
            }
            else if (type === 'return_box') {
                handleChangeRentalBox(this, 'boxReturnStation', stationValue, 'returnBox', result.data);
            }
        } else {
            message.error(result.message);
        }
    };

// 获取国家数据
    /* getCountryData = async (initData, type) => {
     const {setFieldsValue} = this.props.form;
     let result = await reqCountry();
     if (result.code === 200) {
     const countryData = result.data;
     const preInit = initData.countryId ? initData.countryId : countryData.map((pre) => {
     if (pre.id) {
     return pre.id
     } else {
     return ''
     }
     })[0];
     const item = countryData.find(item => preInit === item.id);
     if (item) {
     if (type === 1) {
     this.setState({
     countryDataStart: countryData
     });
     setFieldsValue({originCountryId: preInit});

     if (item.complex == 2) {
     this.getCityData(preInit, initData.cityId, 1)
     } else {
     this.getStateData(preInit, initData, 1)
     }

     } else {
     this.setState({
     countryDataEnd: countryData
     });
     setFieldsValue({destinationCountryId: preInit});
     if (item.complex == 2) {
     this.getCityData(preInit, initData.cityId, 2)
     } else {
     this.getStateData(preInit, initData, 2)
     }
     }
     }
     }
     };*/
//国家 省 城市 三级联动
    /*handleCountryChange = value => {
     const {setFieldsValue} = this.props.form;
     const {countryDataStart} = this.state;
     const item = countryDataStart.find(item => value === item.id);
     if (item) {
     if (item.complex == 2) {
     this.getCityData(value, '', 1);
     this.setState({
     stateDataStart: [],
     })
     setFieldsValue({originProvinceId: ''});
     } else {
     this.getStateData(value, {}, 1);
     this.setState({
     cityDataStart: []
     })
     }

     }

     };

     handleStateChange = value => {
     this.getCityData(value, '', 1)
     };

     handleCountryChange2 = value => {
     const {setFieldsValue} = this.props.form;
     const {countryDataEnd} = this.state;
     const item = countryDataEnd.find(item => value === item.id);
     if (item) {
     if (item.complex == 2) {
     this.getCityData(value, '', 2);
     this.setState({
     stateDataEnd: [],
     });
     setFieldsValue({destinationProvinceId: ''});
     } else {
     this.getStateData(value, {}, 2);
     this.setState({
     cityDataEnd: []
     })
     }

     }
     };

     handleStateChange2 = value => {
     this.getCityData(value, '', 2)
     };

     // 获取省级数据

     getStateData = async (parentId, initData, type) => {
     const {setFieldsValue} = this.props.form;
     let result = await reqState(parentId);
     if (result.code === 200) {
     const stateData = result.data;
     const preInit = initData.stateId ? initData.stateId : stateData.map((pre) => {
     if (pre.id) {
     return pre.id
     } else {
     return ''
     }
     })[0];
     if (type === 1) {
     if (stateData.length > 0) {
     this.setState({
     stateDataStart: stateData,
     });
     setFieldsValue({originProvinceId: preInit});
     this.getCityData(preInit, initData.cityId, type)
     } else {
     this.setState({
     stateDataStart: [],
     cityDataStart: [],
     });
     setFieldsValue({originProvinceId: ''});
     setFieldsValue({originCityId: ''})
     }
     } else {
     if (stateData.length > 0) {
     this.setState({
     stateDataEnd: stateData,
     });
     setFieldsValue({destinationProvinceId: preInit});
     this.getCityData(preInit, initData.cityId, type)
     } else {
     this.setState({
     stateDataEnd: [],
     cityDataEnd: [],
     });
     setFieldsValue({destinationProvinceId: ''});
     setFieldsValue({destinationCityId: ''})
     }
     }


     }
     };

     // 获取市级数据

     getCityData = async (parentId, cityId, type) => {
     const {setFieldsValue} = this.props.form;
     let result = await reqCity(parentId);
     if (result.code === 200) {
     const cityData = result.data;
     const cityInit = cityId ? cityId : cityData.map((pre) => {
     if (pre.id) {
     return pre.id
     }
     })[0];
     if (type === 2) {
     if (cityData) {
     this.setState({
     cityDataEnd: cityData
     });
     setFieldsValue({destinationCityId: cityInit})
     } else {
     setFieldsValue({destinationCityId: ''})
     }
     } else {
     if (cityData) {
     this.setState({
     cityDataStart: cityData
     });
     setFieldsValue({originCityId: cityInit})
     } else {
     setFieldsValue({originCityId: ''})
     }
     }

     }
     };*/
// 获取地址信息
    getAddress = async (type) => {
        let result = await reqAddress(type, orderId);
        const res = result.data;
        if (result.code === 200) {
            if (res.length > 0) {
                const originData = res.map((pre) => {
                    return {
                        id: pre.id,
                        address: pre.address,
                        state: pre.state,
                        country: pre.country,
                        city: pre.city,
                        name: pre.company,
                        phone: pre.phone,
                        contact: pre.contact
                    }
                })[0];
                const {address, tel} = this.getInformation(originData);
                if (type === 3) {
                    this.setState({
                        deliveryPlaceData: res,
                        deliveryPlaceId: originData.id,
                        deliveryPlaceName: originData.name,
                        deliveryPlaceAddress: address,
                        deliveryPlacePhone: originData.phone,
                        deliveryPlaceContact: originData.contact
                    })
                } else if (type === 2) {
                    this.setState({
                        notifyPartyData: res,
                        notifyPartyId: originData.id,
                        notifyPartyName: originData.name,
                        notifyPartyAddress: address,
                        notifyPartyContact: originData.contact,
                    })
                } else if (type === 1) {
                    this.setState({
                        consignorData: res,
                        consignorId: originData.id,
                        consignorName: originData.name,
                        consignorAddress: address
                    })
                } else if (type === 6) {
                    this.setState({
                        consigneeData: res,
                        consignee: originData.name,
                        consigneeAddr: address,
                        consigneeContact: originData.contact,
                        consigneeTel: tel.toString()
                    })
                }
            }
        }
    };
    getInformation = (o) => {
        const address = (o.country ? o.country : '') + (o.state ? o.state : '') + (o.city ? o.city : '') + o.address;
        const tel = [];
        if (o.phone) {
            tel.push(o.phone)
        }
        if (o.email) {
            tel.push(o.email)
        }
        return {
            address, tel
        }
    };
// 发货人变化时
    handleconsignorChange = (key) => {
        const {consignorData} = this.state;
        consignorData.forEach((o, i) => {
            if (key === o.id) {
                const {address, tel} = this.getInformation(o);
                this.props.form.setFieldsValue({
                    shipper: o.company,
                    shipperAddr: address,
                    shipperContact: o.contact,
                    shipperTel: tel.toString()
                })
            }
        })
    };
    consigneeHandleChange = (addrId) => {
        const {consigneeData} = this.state;
        consigneeData.map(o => {
            if (o.id == addrId) {
                const {address, tel} = this.getInformation(o);
                this.props.form.setFieldsValue({
                    consignee: o.company,
                    consigneeAddr: address,
                    consigneeContact: o.contact,
                    consigneeTel: tel.toString()
                })
                this.handleChangeSame(this.state.sameConsignee);
            }
        })
    };
// 通知方变化时
    handlenotifyPartyChange = (key) => {
        const {notifyPartyData} = this.state;
        notifyPartyData.forEach((o, i) => {
            if (key === o.id) {
                const {address, tel} = this.getInformation(o);
                this.props.form.setFieldsValue({
                    notifyParty: o.company,
                    notifyPartyAddr: address,
                    notifyPartyContact: o.contact,
                    notifyPartyTel: tel.toString()
                })
            }
        })
    };

// 提货方变化时
    handledeliveryPlaceChange = (key) => {
        const {deliveryPlaceData} = this.state;
        deliveryPlaceData.forEach((o, i) => {
            if (key === o.id) {
                const {address, tel} = this.getInformation(o);
                this.props.form.setFieldsValue({
                    deliveryPlace: address,
                    contact: o.contact,
                    contactTel: tel.toString()
                })
            }
        })
    };
// 日期选择
    onDateChange = (current, dateString) => {
        if (current) {
            //年月日
            const dateStart = moment().add('days', 6).startOf('day');
            if (current < dateStart) {
                current.add('days', 6);
                dateString = current.format('YYYY-MM-DD HH');
            }
            //小时
            const dateEnd = moment().add('days', 6).endOf('day');
            if (current < dateEnd) {
                const hour = new Date().getHours();
                if (current.hour() <= hour) {
                    current.hour(hour + 1);
                    dateString = current.format('YYYY-MM-DD HH');
                }
            }
        }
        //console.log(current, dateString)
        this.setState({
            deliveryEstimateDt: dateString
        })
    };
    disabledStartDate = (current) => {
        return current && current < moment().add('days', 5).endOf('day');
    };
    disabledDateTime = (current) => {
        if (current && current < moment().add('days', 6).endOf('day')) {
            const hour = new Date().getHours();
            return {
                disabledHours: () => range(0, hour + 1),
            };
        }
    };
    onChangeTradeDt = (value, dateString) => {
        this.setState({
            tradeDt: dateString
        })
    };
// 表单数据初始化
    initFormData = async () => {
        const {setFieldsValue} = this.props.form;
        let result = await getOrder(orderId);
        if (result.code === 200) {
            setFieldsValue({
                deliveryEstimateDt: result.data.deliveryEstimateDt ? moment(result.data.deliveryEstimateDt, 'YYYY-MM-DD HH:mm:ss') : null,
                tradeDt: result.data.tradeDt ? moment(result.data.tradeDt, 'YYYY-MM-DD HH:mm:ss') : null,
            });
            let fArea = this.setInitAreaData(result.data.originCity, "F");
            let tArea = this.setInitAreaData(result.data.destinationCity, "T");
            this.setInitAreaData(result.data.internationalEndCity, "D");
            let rentBox = this.setInitRentalBoxData(result.data.boxRentStation, "rent_box");
            let returnBox = this.setInitRentalBoxData(result.data.boxReturnStation, "return_box");
            /* console.log('fArea')
             console.log(fArea)
             Promise.all([fArea, rentBox]).then(function (results) {
             console.log(results)
             });
             Promise.all([tArea, returnBox]).then(function (results) {
             console.log(results)
             });*/
            const packageType = [];
            Object.getOwnPropertyNames(result.data).forEach(o => {
                if (o === 'packageTypeSmall' || o === 'packageTypeNormal' || o === 'packageTypeNormalOut' 
                    || o === 'packageTypeSale' || o === 'packageTypeDeclare' || o === 'packageTypeTransfer' || o === 'packageTypeB2b' || o === 'packageTypeOverseas')
                    if (result.data[o] === 'Y') {
                        packageType.push(o);
                       // handleChangePackageType(this, o);
                    }
            });
            let deliveryEstimateDt = result.data.deliveryEstimateDt ? result.data.deliveryEstimateDt.substr(0, 13) : '';
            let tradeDt = result.data.tradeDt ? result.data.tradeDt.substr(0, 13) : '';
            result.data.deliveryEstimateDt = deliveryEstimateDt;
            result.data.tradeDt = tradeDt;
            this.setState({readOnly: this.judgeReadOnly(result.data.orderStatus), packageType, ...result.data});
            if(packageType.length>1){
                this.setState({
                    packageTypeStatus:packageTypeStatus[packageType[0]]+'+'+packageTypeStatus[packageType[1]]
                })
            }else{
                this.setState({
                    packageTypeStatus:packageTypeStatus[packageType[0]]
                })
            }
        } else {
            message.error(result.message)
        }
    };
    goods = async (orderId, page = 1, pageSize = 20) => {
        let result = await getPackages({orderId, pageNum: page, pageSize});
        if (result.code === 200) {
            if (result.data) {
                this.setState({
                    page,
                    pageSize,
                    total: result.data.total,
                    packageManageVos: result.data.rows,
                })
            }
        }
        else {
            message.error(result.message)
            return false;
        }
    };
//显示弹窗
    showModal = () => {
        const count = this.state.count + 1;
        this.setState({
            editVisiable: true,
            updateKey: count,
            count: count,
            action: 'add'
        });
    };

//下载PDF
    downloadPdf = () => {
        let name = "order";
        window.location.href = baseUrl + "/api/v1/p/file/fileDownload?id=" + orderId + "&name=" + name;
    };


//显示弹窗
    previewShowModal = () => {
        const previewData = this.state
        //console.log(previewData)
        this.setState({
            previewVisiable: true,
            previewData: previewData
        });
    };


//显示弹窗
    editDataSource = (data) => {
        this.setState({
            editVisiable: true,
            updateKey: data.key,
            action: 'edit'
        });
        this.child.props.form.setFieldsValue(data);
    };

//取消弹窗
    hideModal = () => {
        this.setState({
            editVisiable: false,
        })
    };
//取消弹窗
    previewhideModal = () => {
        this.setState({
            previewVisiable: false,
        })
    };
//储存数据
    saveData = async (updateData) => {
        const {action, page, pageSize} = this.state;
        updateData.orderId = orderId;
        if (updateData.value !== undefined && updateData.pcsNumber !== undefined) {
            updateData.totalValue = toStrFixed(updateData.value * updateData.pcsNumber);
        }
        if (action === 'add') {
            let result = await savePackage(updateData);
            if (result.code == 201) {
                this.goods(orderId, page, pageSize);
            } else {
                message.error(result.message);
            }
        } else {
            let result = await updatePackage(updateData);
            if (result.code == 200) {
                this.goods(orderId, page, pageSize);
            } else {
                message.error(result.message);
            }
        }
    };
    onChange = value => {
        // console.log(value);
    };

    onRef = (ref) => {
        this.child = ref
    };

    handleDelete = async (id) => {
        let result = await delPackage(id, orderId);
        if (result.code == 200) {
            this.goods(orderId);
        } else {
            message.error(result.message);
        }
    };

    handleSubmit = (e, isCommit) => {
        e.preventDefault();
        this.props.form.validateFieldsAndScroll((err, values) => {
            const {packageManageVos, deliveryEstimateDt, tradeDt} = this.state;
            /*if(packageManageVos.length===0){
             return message.error("请填写商品信息")
             }*/
            if (err) {
                message.error(err)
            } else {
                values.id = orderId;
                // values.packageManagePos = packageManageVos;
                values.deliveryEstimateDt = deliveryEstimateDt;
                values.tradeDt = tradeDt;
                values.originCountry = this.state.originCountry;
                values.originEndCountry = this.state.intiCountryValue;
                values.internationalCountry = this.state.intiCountryValue;
                values.internationalEndCountry = this.state.internationalEndCountry;
                values.destinationStartCountry = this.state.destinationStartCountry;
                values.destinationCountry = this.state.destinationCountry;
                values.packageTypeNormal = this.state.packageTypeNormal;
                values.packageTypeNormalOut = this.state.packageTypeNormalOut;
                values.packageTypeSale = this.state.packageTypeSale;
                values.packageTypeSmall = this.state.packageTypeSmall;
                values.packageTypeDeclare = this.state.packageTypeDeclare;
                values.packageTypeTransfer = this.state.packageTypeTransfer;
                values.packageTypeB2b = this.state.packageTypeB2b;
                values.packageTypeOverseas = this.state.packageTypeOverseas;
                values.exportPort = this.state.exportPort;
                values.containerType = this.state.containerType;
                values.shiftDt = this.state.shiftDt;
                delete values.packageType;
                if(values.boxRentStation===undefined){
                    values.boxRentStation=''
                }
                if(values.boxReturnStation===undefined){
                    values.boxReturnStation=''
                }
                values.isCommit = isCommit;
                this.saveTrackData(values);
            }
        });
    };

    saveTrackData = async (data) => {
        let result = await reqUpdateTrack(data);
        if (result.code === 200) {
            this.props.history.replace('/trackList')
        } else {
            message.error(result.message)
        }
    };


// 发货人变化时
    consigneeTelChange = e => {
        this.setState(
            {
                consigneeTel: e.target.value
            }
        )
    }

    consigneeChange = e => {
        this.setState(
            {
                consignee: e.target.value
            }
        )
    }

    consigneeAddrChange = e => {
        this.setState(
            {
                consigneeAddr: e.target.value
            }
        )
    }
    consigneeContactChange = e => {
        this.setState(
            {
                consigneeContact: e.target.value
            }
        )
    }
    importChange = info => {
        let fileList = [...info.fileList];
        let complete = 0;
        fileList = fileList.map(file => {
            if (file.response) {
                // Component will show file.url as link
                if (file.response.code === 200) {
                    message.info(file.response.message);
                    this.goods(orderId);
                } else if (file.response.code === 205) {
                    message.error(file.response.message)
                    window.location.href = baseUrl + '/' + file.response.data;
                } else {
                    message.error(file.response.message)
                }
                file.status = 'done';
                complete = 1;
            }
            return file;
        });
        if (complete === 1) {
            this.setState({
                importList: []
            })
        } else {
            this.setState({importList: fileList});
        }
    };

    downloadModel = () => {
        window.location.href = baseUrl.replace('/oms', '/upload') + '/template/货物管理导入模板.xlsx';
    }
    search = e => {
        e.preventDefault();
        const {page, pageSize} = this.state;
        this.goods(orderId, page, pageSize);
    };
    handleChangeSame = (checked) => {
        if (checked) {
            const {consignee, consigneeAddr, consigneeContact, consigneeTel} = this.props.form.getFieldsValue();
            this.props.form.setFieldsValue({
                notifyParty: consignee,
                notifyPartyAddr: consigneeAddr,
                notifyPartyContact: consigneeContact,
                notifyPartyTel: consigneeTel
            })
        }
        this.setState({sameConsignee: checked})
    };

    render() {
        const {getFieldDecorator} = this.props.form;
        const formItemLayout = {
            labelCol: {span: 9},
            wrapperCol: {span: 14}
        };
        const uploadProps = {
            name: 'file',
            action: baseUrl + '/api/v1/p/oms/import',
            withCredentials: true,
            onChange: this.importChange,
            showUploadList: false,
            fileList: this.state.importList,
            accept: ".xls,.xlsx,application/vnd.ms-excel",
        };
        const {
            editVisiable, packageManageVos, updateKey, consignorData, notifyPartyData, deliveryPlaceData, previewVisiable, previewData,
        } = this.state;
        const columns = [
            {
                title: '唛码标记Marks',
                dataIndex: 'boxNo',
            }, {
                title: '品名(中文)',
                dataIndex: 'name',
            }, {
                title: '品名(英文)',
                dataIndex: 'nameEn',
            }, {
                title: '国内HSCode',
                dataIndex: 'hscode',
            }, {
                title: '国外HSCode',
                dataIndex: 'oHscode',
            }, {
                title: '箱数CTNS',
                dataIndex: 'num',
            }, {
                title: '件数PCS',
                dataIndex: 'pcsNumber',
            }, {
                title: '毛重(Kg)',
                dataIndex: 'grossWeight',
            }, {
                title: '净重(Kg)',
                dataIndex: 'netWeight',
            }, {
                title: '体积(CBM)',
                dataIndex: 'volume',
            }, {
                title: '单价/币制Value unit',
                dataIndex: 'value',
                render: (text, record) => {
                    if (text === undefined || text === null) {
                        return
                    } else {
                        return text + '/' + record.currency;
                    }
                }
            }, {
                title: '总价/币制Value & Currency',
                dataIndex: 'totalValue',
                render: (text, record) => {
                    if (text === undefined || text === null) {
                        return
                    } else {
                        return text + '/' + record.currency;
                    }
                }
            }, {
                title: '成分',
                dataIndex: 'ingredient',
            }, {
                title: '用途',
                dataIndex: 'application',
            }, {
                title: '操作',
                dataIndex: 'opt',
                render: (text, record) => {
                    return (
                        <span> <a onClick={() => this.editDataSource(record)}
                                  style={{marginRight: 8}}>
                                        修改
                                    </a>
                            <Popconfirm title="是否确定删除?" onConfirm={() => this.handleDelete(record.id)}>
                            <a>删除</a>
                        </Popconfirm>
                        </span>
                    );
                }
            }
        ];
        return (
            <div className='order-space'>
                <Form onSubmit={e => this.handleSubmit(e, 'N')} autoComplete='off' {...formItemLayout}>
                    <div className="order-base-title">
                        基本信息
                    </div>
                    <div className="order-spaceInfo-content">
                        <span><span>国内陆运:</span></span>
                        <div className='spaceInfo-content-info'>
                            <Row>
                                <Col span={8}>
                                    <SelectAreaFormItem
                                        label='起运地'
                                        name="originCity"
                                        getFieldDecorator={getFieldDecorator}
                                        initialValue={this.state.originCity}
                                        handleChange={e => {
                                            handleChangeArea(this, 'originCity', e, 'originCountry', 'origin', null, 'boxRentStation')
                                        }}
                                        disabledOpt={this.state.readOnly}
                                        data={[...this.state['origin']]}
                                    />
                                </Col>
                                <Col span={8}>
                                    <SelectAreaFormItem
                                        label='目的地'
                                        name="originEndCity"
                                        getFieldDecorator={getFieldDecorator}
                                        initialValue={this.state.intiCityValue}
                                        disabledOpt={true}
                                        data={this.state.origin}
                                    />
                                </Col>
                                <Col span={8}>
                                    <Form.Item>
                                        {getFieldDecorator('originDeliveryType', {
                                            initialValue: this.state.originDeliveryType ? this.state.originDeliveryType : 'D',
                                            rules: [{required: true, message: '该项必填'}],
                                        })(<Radio.Group disabled={this.state.readOnly}>
                                                <Radio value='D'>代运</Radio>
                                                <Radio value='Z'>自运</Radio>
                                                <Tooltip title="自运：由贵司承运；代运：由我司承运！">
                                                    <IconFont type="icon-wenhaow"/>
                                                </Tooltip>
                                            </Radio.Group>
                                        )}
                                    </Form.Item>
                                </Col>
                            </Row>
                        </div>
                        <span><span>国际铁路:</span></span>
                        <div className='spaceInfo-content-info'>
                            <Row>
                                <Col span={8}>
                                    <SelectAreaFormItem
                                        label='起运地'
                                        name="internationalCity"
                                        getFieldDecorator={getFieldDecorator}
                                        initialValue={this.state.intiCityValue}
                                        disabledOpt={true}
                                        data={this.state.origin}
                                    />
                                </Col>
                                <Col span={8}>
                                    <SelectAreaFormItem
                                        label='目的地'
                                        name="internationalEndCity"
                                        getFieldDecorator={getFieldDecorator}
                                        initialValue={this.state.destinationStartCity}
                                        disabledOpt={this.state.readOnly}
                                        data={this.state.international}
                                        handleChange={e => {
                                            handleChangeArea(this, 'internationalEndCity', e, 'internationalEndCountry', 'international');
                                            handleChangeArea(this, 'destinationStartCity', e, 'destinationStartCountry', 'international');
                                        }}
                                    />
                                </Col>
                                <Col span={8}>
                                    <SelectShiftItem
                                        label='班次时间'
                                        name="shiftDt"
                                        getFieldDecorator={getFieldDecorator}
                                        initialValue={this.state.shiftDt}
                                        disabledOpt={this.state.readOnly}
                                        data={this.state.shiftList}
                                        handleChange={e => {
                                            handleChangeShift(this, 'shiftDt', e, 'shiftList');
                                        }}
                                    />
                                </Col>
                            </Row>
                        </div>
                        <span><span>欧洲公路/铁路转运:</span></span>
                        <div className='spaceInfo-content-info'>
                            <Row>
                                <Col span={8}>
                                    <SelectAreaFormItem
                                        label='转关地'
                                        name="destinationStartCity"
                                        getFieldDecorator={getFieldDecorator}
                                        initialValue={this.state.destinationStartCity}
                                        disabledOpt={this.state.readOnly}
                                        data={this.state.international}
                                        handleChange={e => {
                                            handleChangeArea(this, 'internationalEndCity', e, 'internationalEndCountry', 'international')
                                            handleChangeArea(this, 'destinationStartCity', e, 'destinationStartCountry', 'international')
                                        }}
                                    />
                                </Col>
                                <Col span={8}>
                                    <SelectAreaFormItem
                                        label='目的地'
                                        name="destinationCity"
                                        getFieldDecorator={getFieldDecorator}
                                        initialValue={this.state.destinationCity}
                                        disabledOpt={this.state.readOnly}
                                        data={this.state.destination}
                                        handleChange={e => {
                                            handleChangeArea(this, 'destinationCity', e, 'destinationCountry', 'destination', null, 'boxReturnStation')
                                        }}
                                    />
                                </Col>
                                <Col span={8}>
                                    <Form.Item>
                                        {getFieldDecorator('destinationDeliveryType', {
                                            initialValue: this.state.destinationDeliveryType ? this.state.destinationDeliveryType : 'D',
                                            rules: [{required: true, message: '该项必填'}],
                                        })(<Radio.Group disabled={this.state.readOnly}>
                                                <Radio value='D'>代运</Radio>
                                                <Radio value='Z'>自运</Radio>
                                                <Tooltip title="自运：由贵司承运；代运：由我司承运！">
                                                    <IconFont type="icon-wenhaow"/>
                                                </Tooltip>
                                            </Radio.Group>
                                        )}
                                    </Form.Item>
                                </Col>
                                <Col span={8}>
                                    <Form.Item label="出境口岸">
                                            {getFieldDecorator('exportPort', {
                                                initialValue: this.state.exportPort,
                                                rules: [{
                                                    required: true, 
                                                    message: '该项必填'
                                                }],
                                            })(<Select disabled={this.state.readOnly} onChange={e => { this.setState({exportPort: e, change: true});}}>
                                                    <Option value='阿拉山口'>阿拉山口</Option>
                                                    <Option value='二连浩特'>二连浩特</Option>
                                                    <Option value='霍尔果斯'>霍尔果斯</Option>
                                                    <Option value='满洲里'>满洲里</Option>
                                                    <Option value='磨憨'>磨憨</Option>
                                                    <Option value='阿拉山口（马拉线）'>阿拉山口（马拉线）</Option>
                                                    <Option value='阿拉山口（乔普线）'>阿拉山口（乔普线）</Option>
                                                </Select>)}
                                    </Form.Item>
                                </Col>
                            </Row>
                        </div>
                        <span><span>其他信息:</span></span>
                        <div className='spaceInfo-content-info'>
                            <Row>
                                <Col span={8}>
                                    <SelectBoxFormItem
                                        label='租箱地'
                                        name="boxRentStation"
                                        getFieldDecorator={getFieldDecorator}
                                        initialValue={this.state.boxRentStation}
                                        disabledOpt={this.state.readOnly}
                                        data={this.state.rentBox}
                                        handleChange={e => {
                                            handleChangeRentalBox(this, 'boxRentStation', e, 'rentBox')
                                        }}
                                    />
                                </Col>
                                <Col span={8}>
                                    <SelectBoxFormItem
                                        label='还箱地'
                                        name="boxReturnStation"
                                        getFieldDecorator={getFieldDecorator}
                                        initialValue={this.state.boxReturnStation}
                                        disabledOpt={this.state.readOnly}
                                        data={this.state.returnBox}
                                        handleChange={e => {
                                            handleChangeRentalBox(this, 'boxReturnStation', e, 'returnBox')
                                        }}
                                    />
                                </Col>
                                </Row>
                                <Row>
                                <Col span={8}>
                                    <Form.Item label="集装箱数">
                                        {getFieldDecorator('containerNum', {
                                            initialValue: this.state.containerNum,
                                            rules: [{
                                                required: true,
                                                message: '该项必填'
                                            }, {
                                                pattern: /^[1-9]\d*$/,
                                                message: '必须为大于0的整数'
                                            }]
                                        })(
                                            <Input placeholder='集装箱数'  onChange={e => {
                                                this.setState({containerNum: e.target.value})
                                            }} readOnly={this.state.readOnly} disabled={true}/>
                                        )}
                                    </Form.Item>
                                </Col>
                                <Col span={8}>
                                    <Form.Item label="集装箱类型">
                                        {getFieldDecorator('containerType', {
                                            initialValue: this.state.containerType,
                                            rules: [{
                                                required: true, 
                                                message: '该项必填'
                                            }],
                                        })(<Select disabled={this.state.readOnly}
                                            onChange={e => {
                                            this.setState({containerType: e, change: true});
                                        }}>
                                            <Option value='40HQ'>40HQ</Option>
                                            <Option value='40GP'>40GP</Option>
                                            <Option value='20GP'>20GP</Option>
                                            <Option value='45GP'>45GP</Option>
                                        </Select>)}
                                    </Form.Item>
                                </Col>
                            </Row>
                            <Row>
                                <Col span={24}>
                                    <Form.Item label="货物类型" {...{
                                            labelCol: {span:3},
                                            wrapperCol: {span: 21}
                                        }}>
                                        {getFieldDecorator('packageTypeStatus', {
                                                initialValue: this.state.packageTypeStatus,
                                                rules: [{required: true, message: '该项必填'
                                                }],
                                            })(<Select disabled={this.state.readOnly} onChange={e => handleChangePackageType(this, e) }>
                                                    <Option value='packageTypeSmall+packageTypeTransfer'>零售小包+转关运输</Option>
                                                    <Option value='packageTypeSmall+packageTypeDeclare'>零售小包+通关一体化</Option>
                                                    <Option value='packageTypeNormal+packageTypeSale'>本地一般贸易+寄售代销</Option>
                                                    <Option value='packageTypeNormal+packageTypeDeclare'>本地一般贸易+通关一体化</Option>
                                                    <Option value='packageTypeNormal+packageTypeTransfer'>本地一般贸易+转关运输</Option>
                                                    <Option value='packageTypeNormalOut+packageTypeSale'>外地一般贸易+寄售代销</Option>
                                                    <Option value='packageTypeNormalOut+packageTypeDeclare'>外地一般贸易+通关一体化</Option>
                                                    <Option value='packageTypeNormalOut+packageTypeTransfer'>外地一般贸易+转关运输</Option>
                                                    <Option value='packageTypeSale+packageTypeTransfer'>寄售代销+转关运输</Option>
                                                    <Option value='packageTypeSale+packageTypeDeclare'>寄售代销+通关一体化</Option>
                                                    <Option value='packageTypeB2b+packageTypeTransfer'>B2B直接出口+转关运输</Option>
                                                    <Option value='packageTypeB2b+packageTypeDeclare'>B2B直接出口+通关一体化</Option>
                                                    <Option value='packageTypeOverseas+packageTypeTransfer'>出口海外仓+转关运输</Option>
                                                    <Option value='packageTypeOverseas+packageTypeDeclare'>出口海外仓+通关一体化</Option>
                                                </Select>)}
                                    </Form.Item>
                                </Col>
                            </Row>
                        </div>
                    </div>
                    <div className="order-base-title">
                        发货企业信息
                    </div>
                    <div className="order-spaceInfo-content">
                        <span><span>发货企业信息:</span></span>
                        <Select onChange={this.handleconsignorChange}
                                getPopupContainer={triggerNode => triggerNode.parentNode}
                                disabled={this.state.readOnly}>
                            {consignorData.map(country => (
                                <Option key={country.id} value={country.id}>{country.company}</Option>
                            ))}
                        </Select>
                        <div className='spaceInfo-content-info'>
                            <Row>
                                <Col span={12}>
                                    <Form.Item label="发货企业名称">
                                        {getFieldDecorator('shipper', {
                                            initialValue: this.state.shipper,
                                            rules: [{required: true, message: '该项必填'}],
                                        })(
                                            <Input placeholder="发货企业名称" onChange={e => {
                                                this.setState({shipper: e.target.value})
                                            }} readOnly={this.state.readOnly}/>,
                                        )}
                                    </Form.Item>
                                </Col>
                                <Col span={12}>
                                    <Form.Item label="发货企业地址" {...formItemLayout}>
                                        {getFieldDecorator('shipperAddr', {
                                            initialValue: this.state.shipperAddr,
                                            rules: [{required: true, message: '该项必填'}],
                                        })(
                                            <Input placeholder="发货企业地址" onChange={e => {
                                                this.setState({shipperAddr: e.target.value})
                                            }} readOnly={this.state.readOnly}/>,
                                        )}
                                    </Form.Item>
                                </Col>
                                <Col span={12}>
                                    <Form.Item label="发货企业联系人" {...formItemLayout}>
                                        {getFieldDecorator('shipperContact', {
                                            initialValue: this.state.shipperContact,
                                        })(
                                            <Input placeholder="发货企业联系人" onChange={e => {
                                                this.setState({shipperContact: e.target.value})
                                            }} readOnly={this.state.readOnly}/>,
                                        )}
                                    </Form.Item>
                                </Col>
                                <Col span={12}>
                                    <Form.Item label="发货企业联系方式" {...formItemLayout}>
                                        {getFieldDecorator('shipperTel', {
                                            initialValue: this.state.shipperTel,
                                        })(
                                            <Input placeholder="发货企业联系方式" onChange={e => {
                                                this.setState({shipperTel: e.target.value})
                                            }} readOnly={this.state.readOnly}/>,
                                        )}
                                    </Form.Item>
                                </Col>
                            </Row>
                        </div>
                    </div>
                    <div className="order-base-title">
                        境外收货方信息
                    </div>
                    <div className="order-spaceInfo-content">
                        <span><span>境外收货方信息:</span></span>
                        <Select onChange={this.consigneeHandleChange}
                                getPopupContainer={triggerNode => triggerNode.parentNode}
                                disabled={this.state.readOnly}>
                            {this.state.consigneeData.map(d => (
                                <Option key={d.id} value={d.id}>{d.company}</Option>
                            ))}
                        </Select>
                        <div className='spaceInfo-content-info'>
                            <Row>
                                <Col span={12}>
                                    <Form.Item label="境外收货方名称" {...formItemLayout}>
                                        {getFieldDecorator('consignee', {
                                            initialValue: this.state.consignee,
                                            rules: [{required: true, message: '该项必填'}],
                                        })(<Input onChange={this.consigneeChange} readOnly={this.state.readOnly}/>)}
                                    </Form.Item>
                                </Col>
                                <Col span={12}>
                                    <Form.Item label="境外收货方地址" {...formItemLayout}>
                                        {getFieldDecorator('consigneeAddr', {
                                            initialValue: this.state.consigneeAddr,
                                            rules: [{required: true, message: '该项必填'}],
                                        })(<Input onChange={this.consigneeAddrChange}
                                                  readOnly={this.state.readOnly}/>)}
                                    </Form.Item>
                                </Col>
                                <Col span={12}>
                                    <Form.Item label="境外收货方联系人" {...formItemLayout}>
                                        {getFieldDecorator('consigneeContact', {
                                            initialValue: this.state.consigneeContact,
                                        })(<Input onChange={this.consigneeContactChange}
                                                  readOnly={this.state.readOnly}/>)}
                                    </Form.Item>
                                </Col>
                                <Col span={12}>
                                    <Form.Item label="境外收货方联系方式" {...formItemLayout}>
                                        {getFieldDecorator('consigneeTel', {
                                            initialValue: this.state.consigneeTel,
                                        })(<Input onChange={this.consigneeTelChange}
                                                  readOnly={this.state.readOnly}/>)}
                                    </Form.Item>
                                </Col>
                            </Row>
                        </div>
                    </div>
                    <div className="order-base-title">
                        通知方信息<span style={{marginLeft: '10px'}}>
                        <Checkbox value="sameConsignee" disabled={this.state.readOnly}
                                  onChange={e => {
                                      this.handleChangeSame(e.target.checked)
                                  }}>同境外收货方</Checkbox></span>
                    </div>
                    <div className="order-spaceInfo-content">
                        <span><span>通知方信息:</span></span>
                        <Select onChange={this.handlenotifyPartyChange}
                                getPopupContainer={triggerNode => triggerNode.parentNode}
                                disabled={this.state.readOnly}>
                            {notifyPartyData.map(notify => (
                                <Option key={notify.id} value={notify.id}>{notify.company}</Option>
                            ))}
                        </Select>
                        <div className='spaceInfo-content-info'>
                            <Row>
                                <Col span={12}>
                                    <Form.Item label="通知方名称" {...formItemLayout}>
                                        {getFieldDecorator('notifyParty', {
                                            initialValue: this.state.notifyParty,
                                            rules: [{required: true, message: '该项必填'}],
                                        })(
                                            <Input placeholder="通知方名称" onChange={e => {
                                                this.setState({notifyParty: e.target.value})
                                            }} readOnly={this.state.readOnly}/>,
                                        )}
                                    </Form.Item>
                                </Col>
                                <Col span={12}>
                                    <Form.Item label="通知方地址" {...formItemLayout}>
                                        {getFieldDecorator('notifyPartyAddr', {
                                            initialValue: this.state.notifyPartyAddr,
                                        })(
                                            <Input placeholder="通知方地址" onChange={e => {
                                                this.setState({notifyPartyAddr: e.target.value})
                                            }} readOnly={this.state.readOnly}/>,
                                        )}
                                    </Form.Item>
                                </Col>
                                <Col span={12}>
                                    <Form.Item label="通知方联系人" {...formItemLayout}>
                                        {getFieldDecorator('notifyPartyContact', {
                                            initialValue: this.state.notifyPartyContact,
                                        })(
                                            <Input placeholder="通知方联系人" onChange={e => {
                                                this.setState({notifyPartyContact: e.target.value})
                                            }} readOnly={this.state.readOnly}/>,
                                        )}
                                    </Form.Item>
                                </Col>
                                <Col span={12}>
                                    <Form.Item label="通知方联系方式" {...formItemLayout}>
                                        {getFieldDecorator('notifyPartyTel', {
                                            initialValue: this.state.notifyPartyTel,
                                        })(
                                            <Input placeholder="通知方联系方式" onChange={e => {
                                                this.setState({notifyPartyTel: e.target.value})
                                            }} readOnly={this.state.readOnly}/>,
                                        )}
                                    </Form.Item>
                                </Col>
                            </Row>
                        </div>
                    </div>
                    <div className="order-base-title">
                        仓库联系人信息
                    </div>
                    <div className="order-spaceInfo-content">
                        <span><span>仓库联系人信息:</span></span>
                        <Select onChange={this.handledeliveryPlaceChange}
                                getPopupContainer={triggerNode => triggerNode.parentNode}
                                disabled={this.state.readOnly}>
                            {deliveryPlaceData.map(delivery => (
                                <Option key={delivery.id} value={delivery.id}>{delivery.company}</Option>
                            ))}
                        </Select>
                        <div className='spaceInfo-content-info'>
                            <Row>
                                <Col span={12}>
                                    <Form.Item label="仓库地点" {...formItemLayout}>
                                        {getFieldDecorator('deliveryPlace', {
                                            initialValue: this.state.deliveryPlace,
                                            rules: [{required: true, message: '该项必填'}],
                                        })(
                                            <Input placeholder="仓库地点" onChange={e => {
                                                this.setState({deliveryPlace: e.target.value})
                                            }} readOnly={this.state.readOnly}/>,
                                        )}
                                    </Form.Item>
                                </Col>
                                <Col span={12}>
                                    <Form.Item label="预计提货时间" {...formItemLayout}>
                                        {getFieldDecorator('deliveryEstimateDt', {
                                            rules: [{required: true, message: '该项必填'}],
                                        })(<DatePicker
                                            format="YYYY-MM-DD HH"
                                            onChange={this.onDateChange} style={{width: '100%'}}
                                            disabledDate={this.disabledStartDate}
                                            disabledTime={this.disabledDateTime}
                                            showTime={{defaultValue: moment(new Date().getHours() + 1, 'HH')}}
                                        />)}
                                    </Form.Item>
                                </Col>
                                <Col span={12}>
                                    <Form.Item label="仓库联系人" {...formItemLayout}>
                                        {getFieldDecorator('contact', {
                                            initialValue: this.state.contact,
                                            rules: [{required: true, message: '该项必填'}],
                                        })(
                                            <Input placeholder="仓库联系人" onChange={e => {
                                                this.setState({contact: e.target.value})
                                            }} readOnly={this.state.readOnly}/>,
                                        )}
                                    </Form.Item>
                                </Col>
                                <Col span={12}>
                                    <Form.Item label="仓库联系人方式" {...formItemLayout}>
                                        {getFieldDecorator('contactTel', {
                                            initialValue: this.state.contactTel,
                                            rules: [{required: true, message: '该项必填'}],
                                        })(
                                            <Input placeholder="仓库联系人方式" onChange={e => {
                                                this.setState({contactTel: e.target.value})
                                            }} readOnly={this.state.readOnly}/>,
                                        )}
                                    </Form.Item>
                                </Col>
                            </Row>
                        </div>
                    </div>
                    <TrackModel
                        previewVisiable={previewVisiable}
                        hideModal={ this.previewhideModal }
                        previewData={previewData}
                    />
                    <div className="order-track-opt">
                        {this.state.readOnly ? '' : <AuthButton authority="order_edit:order_save" type='primary'
                                                                htmlType="submit">保存</AuthButton>}
                        {this.state.readOnly ? '' :
                            <AuthPopconfirm title="是否确定保存并提交?" onConfirm={e => this.handleSubmit(e, 'Y')}>
                                <Button type='primary'>保存并提交</Button>
                            </AuthPopconfirm>}
                        {/* <AuthButton authority="order_edit:order_download" type='primary'
                         onClick={this.downloadPdf}>下载</AuthButton>*/}
                        <AuthButton authority="order_edit:order_view" type='primary'
                                    onClick={this.previewShowModal}>预览</AuthButton>
                    </div>
                </Form>
            </div>
        )
    }
}

const WrapMmsOrderTrack = Form.create()(OrderTrack)
export default WrapMmsOrderTrack